import React from "react";
import { Heart, Leaf, ShieldCheck, Star } from "lucide-react";

/** Values row — the four sage circle badges from the email signature. */
const VALUES = [
  { icon: Heart, label: "Person Centred" },
  { icon: Leaf, label: "Trauma Informed" },
  { icon: ShieldCheck, label: "Community Focused" },
  { icon: Star, label: "Empowering Change" },
];

export default function ValuesRow({ tone = "light", compact = false }) {
  const labelColor = tone === "dark" ? "text-njas-bg" : "text-njas-navy";
  const iconStyle =
    tone === "dark"
      ? { background: "transparent", border: "1.5px solid rgba(228,234,225,0.7)", color: "#E4EAE1" }
      : { background: "var(--njas-sage)", color: "var(--njas-bg)" };

  return (
    <div
      data-testid="values-row"
      className={`grid ${compact ? "grid-cols-2 sm:grid-cols-4" : "grid-cols-2 md:grid-cols-4"} gap-y-8 ${compact ? "gap-x-4" : "gap-x-6"}`}
    >
      {VALUES.map(({ icon: Icon, label }, i) => (
        <div key={label} className="flex items-center gap-4 relative" data-testid={`value-${label.toLowerCase().replace(/\s+/g, "-")}`}>
          <div
            className="njas-badge shrink-0"
            style={iconStyle}
          >
            <Icon className="w-5 h-5" strokeWidth={1.8} />
          </div>
          <div className={`njas-value-label ${labelColor}`}>{label}</div>
          {/* faint sage vertical rule between columns on md+ */}
          {i < VALUES.length - 1 && (
            <div className="hidden md:block absolute -right-3 top-1 bottom-1 w-px bg-[var(--njas-sage)] opacity-40" />
          )}
        </div>
      ))}
    </div>
  );
}
